import ArrowDownIcon from './icons/arrow-down.svg'
import ArrowRightIcon from './icons/arrow-right.svg'
import ArrowLeftIcon from './icons/arrow-left.svg'
import EditIconPen from './icons/edit-pen-icon.svg'
import PlusIcon from './icons/plus-icon.svg'
import LockIcon from './icons/lock-icon.svg'
import MenuIcon from './icons/menu.svg'
import FolderIcon from './icons/folder.svg'
import NewTabIcon from './icons/new-tab.svg'
import TrashCanIcon from './icons/trash-can.svg'
import WebsiteIcon from './icons/website_icon.svg'
import LocationIcon from './icons/location_pin_icon.svg'
import ClockIcon from './icons/clock.svg'
import LogoutIcon from './icons/logout.svg'
import ProfileIcon from './icons/profile.svg'
import SearchIcon from './icons/search.svg'
import SearchIconWhite from './icons/search_white.svg'
import CloseIcon from './icons/close.svg'
import AudienceIcon from './icons/audience.svg'
import InboxUnreadIcon from './icons/inbox-unread.svg'
import InboxIcon from './icons/inbox.svg'
import SettingsIcon from './icons/settings.svg'
import NotificationIcon from './icons/notification.svg'
import BellIcon from './icons/bell.svg'
import FlagIcon from './icons/flag.svg'
import ContentIcon from './icons/content.svg'
import SmileyFaceIcon from './icons/smiley-face.svg'
import InsightIcon from './icons/insight.svg'
import UserIcon from './icons/user.svg'
import HeartIcon from './icons/heart.svg'
import AddImageIcon from './icons/add-image.svg'
import AttachmentIcon from './icons/attachment.svg'
import UsersIcon from './icons/users.svg'
import MedalIcon from './icons/medal.svg'
import CreatorlandIcon from './icons/creatorland.svg'
import CheckmarkIcon from './icons/checkmark.svg'
import ProfilesIcon from './icons/profiles.svg'
import ThreeDotsIcon from './icons/three-dots.svg'
import HiddenIcon from './icons/hidden-icon.svg'
import CreatorlandiconGreend from './icons/creatorland-icon-green.svg'
import InfoCircle from './icons/info-circle.svg'
import VisibleIcon from './icons/visible-icon.svg'
import LikeIcon from './icons/like-icon.svg'
import CommentIcon from './icons/comment-icon.svg'
import ShareIcon from './icons/share-icon.svg'
import TrendIcon from './icons/trend-icon.svg'
import BlueCheckIcon from './icons/blue-check.svg'
import ShareArrow from './icons/share-arrow.svg'
import ShieldSecurity from './icons/shield-security.svg'
import DiscoverIcon from './icons/discover-icon.svg'
import EmptyHeart from './icons/empty-heart.svg'
import ColoredHeart from './icons/colored-heart.svg'
import PictureIcon from './icons/picture-icon.svg'
import InsidersLifeTimeBadge from './icons/insiders-lifetime-badge.svg'
import InsidersLifeTimeBadgePNG from './icons/insiders-lifetime-badge.png'
import JobsIcon from './icons/jobs.svg'
import InsidersSubBadgePNG from './icons/insiders-sub-badge.png'
import InsidersProSubBadgePNG from './icons/insiders-pro-sub-badge.png'
import AnalyticsIconClockPNG from './analytics/icon-clock.png'
import AnalyticsIconPeoplePNG from './analytics/icon-people.png'
import AnalyticsIconGraphPNG from './analytics/icon-graph.png'
import AnalyticsIconTrophyPNG from './analytics/icon-trophy.png'
import AnalyticsIconVennDiagramPNG from './analytics/icon-venn.png'
import AnalyticsIconCheckmarkPNG from './analytics/icon-checkmark.png'
import CoCreatorIcon from './icons/co-creator-icon.svg'
import CoCreatorPNG from './icons/co-creator-icon.png'
import University from './icons/university-icon.svg'
import SupportIcon from './icons/support-icon.svg'
import EyeIcon from '../../icons/eye-icon.svg'

const Icon = {
  ArrowDownIcon,
  ArrowRightIcon,
  CoCreatorIcon,
  EditIconPen,
  PlusIcon,
  LocationIcon,
  AudienceIcon,
  CloseIcon,
  AddImageIcon,
  AttachmentIcon,
  MenuIcon,
  LogoutIcon,
  TrashCanIcon,
  ArrowLeftIcon,
  NewTabIcon,
  LockIcon,
  ProfileIcon,
  ThreeDotsIcon,
  SettingsIcon,
  SearchIcon,
  SearchIconWhite,
  JobsIcon,
  FolderIcon,
  ClockIcon,
  NotificationIcon,
  CheckmarkIcon,
  SmileyFaceIcon,
  InsightIcon,
  HeartIcon,
  InboxUnreadIcon,
  InboxIcon,
  InsidersLifeTimeBadge,
  InsidersLifeTimeBadgePNG,
  InsidersSubBadgePNG,
  InsidersProSubBadgePNG,
  FlagIcon,
  ProfilesIcon,
  ContentIcon,
  UserIcon,
  CreatorlandIcon,
  UsersIcon,
  MedalIcon,
  HiddenIcon,
  CreatorlandiconGreend,
  InfoCircle,
  VisibleIcon,
  LikeIcon,
  CommentIcon,
  ShareIcon,
  TrendIcon,
  BlueCheckIcon,
  ShareArrow,
  ShieldSecurity,
  DiscoverIcon,
  PictureIcon,
  AnalyticsIconClockPNG,
  AnalyticsIconPeoplePNG,
  AnalyticsIconGraphPNG,
  AnalyticsIconTrophyPNG,
  AnalyticsIconVennDiagramPNG,
  AnalyticsIconCheckmarkPNG,
  BellIcon,
  University,
  SupportIcon,
  CoCreatorPNG,
  EyeIcon
}

export {
  LockIcon,
  Icon,
  ArrowDownIcon,
  ArrowRightIcon,
  FolderIcon,
  CreatorlandIcon,
  TrashCanIcon,
  ClockIcon,
  ProfilesIcon,
  NewTabIcon,
  EditIconPen,
  JobsIcon,
  InboxIcon,
  InsidersLifeTimeBadge,
  InsidersLifeTimeBadgePNG,
  InsidersSubBadgePNG,
  InsidersProSubBadgePNG,
  PlusIcon,
  MenuIcon,
  CloseIcon,
  LogoutIcon,
  ProfileIcon,
  SearchIcon,
  SearchIconWhite,
  NotificationIcon,
  LocationIcon,
  UserIcon,
  CheckmarkIcon,
  ArrowLeftIcon,
  AddImageIcon,
  AttachmentIcon,
  UsersIcon,
  ThreeDotsIcon,
  HeartIcon,
  MedalIcon,
  WebsiteIcon,
  ContentIcon,
  SmileyFaceIcon,
  InboxUnreadIcon,
  FlagIcon,
  InsightIcon,
  HiddenIcon,
  CreatorlandiconGreend,
  InfoCircle,
  VisibleIcon,
  LikeIcon,
  CommentIcon,
  ShareIcon,
  TrendIcon,
  BlueCheckIcon,
  ShareArrow,
  AudienceIcon,
  ShieldSecurity,
  DiscoverIcon,
  PictureIcon,
  AnalyticsIconClockPNG,
  AnalyticsIconPeoplePNG,
  AnalyticsIconGraphPNG,
  AnalyticsIconTrophyPNG,
  AnalyticsIconVennDiagramPNG,
  AnalyticsIconCheckmarkPNG,
  EmptyHeart,
  ColoredHeart,
  BellIcon,
  University,
  SupportIcon,
  CoCreatorPNG,
  EyeIcon
}

export type IconName = keyof typeof Icon
